<template>
    <div class="member-bottom-button-container">
        <div class="member-popup-footer" @click="handleShowPopup">
            <div class="member-popup-button">成为骑士会员，立享当前权益 <i class="icon-arrow" /></div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        handleShowPopup() {
            this.$emit('show-popup');
        },
    },
};
</script>

<style lang="scss" scoped>
.member-bottom-button-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    z-index: 6;
    background: #fff;
    display: flex;
    padding-bottom: calc(env(safe-area-inset-bottom));
    padding-bottom: calc(constant(safe-area-inset-bottom));
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);

    .member-popup-footer {
        width: 6.9rem;
        height: 0.88rem;
        background: linear-gradient(90deg, #4f4f4f 0%, #252220 100%);
        border-radius: 0.44rem;
        margin: 0.16rem auto 0;
        color: #f8e3c0;
        animation: animatedScale 1.8s linear infinite;

        .member-popup-button {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: 0 0 / contain no-repeat url(../../assets/images/light.png);
            animation: animatedBackground 1.8s linear infinite;
            font-size: 0.28rem;
            font-weight: 500;

            .icon-arrow {
                width: 0.147rem;
                height: 0.147rem;
                background: center / 100% 100% url('../../assets/images/arrow.png');
                margin-left: 0.08rem;
            }
        }
    }
}

@keyframes animatedBackground {
    0% {
        background-position: 0 0;
    }
    30% {
        background-position: 120% 0;
    }
    100% {
        background-position: 120% 0;
    }
}

@keyframes animatedScale {
    0% {
        transform: scale(1);
    }
    45% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    60% {
        transform: scale(1);
    }
    70% {
        transform: scale(1.05);
    }
    80% {
        transform: scale(1);
    }
}
</style>
